import { useCallback } from 'react';

import { useToast } from '../components/Toast';

export function useCopyToClipboard() {
  const toast = useToast();
  const copyToClipboard = useCallback(
    (content: string) => {
      navigator.clipboard
        .writeText(content)
        .then(() => {
          toast.open('Content copied to clipboard', { variant: 'success', autoHideDuration: 1000 });
        })
        .catch((clipboardError) => {
          console.error(
            'Failed to copy text via navigator.clipboard, attempting fallback technique',
            clipboardError
          );
          /**
           * Fall back to creating a textarea and copying the content
           * This requires a user to first interact with the page.
           */
          try {
            const textArea = document.createElement('textarea');
            textArea.value = content;
            textArea.setAttribute('readonly', '');
            textArea.style.position = 'absolute';
            textArea.style.left = '-9999px';
            document.body.appendChild(textArea);
            textArea.select();
            /**
             * Unfortunately, document.execCommand is deprecated and may be removed in the future.
             * However, it is the only fallback technique we have.
             */
            document.execCommand('copy');
            document.body.removeChild(textArea);
          } catch (documentCopyError) {
            console.error('Failed to copy text via fallback technique', documentCopyError);
            toast.showError('Failed to copy content to clipboard');
          }
        });
    },
    [toast]
  );

  return { copyToClipboard };
}
